export default __webpack_public_path__ + "locales/de/DeleteDialog.json?hash=f77bcd72a0c6d730b4fe5f441d500968";